import React, { useState, useEffect } from "react";

const PrivacyNotice: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const closed = sessionStorage.getItem("privacyNoticeClosed");
    if (closed === "true") {
      setIsVisible(false);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("privacyNoticeClosed", "true");
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        backgroundColor: "rgba(255, 152, 0, 0.15)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 152, 0, 0.3)",
        borderRadius: "12px",
        padding: "16px",
        marginBottom: "16px",
        position: "relative",
      }}
    >
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          background: "none",
          border: "none",
          color: "#FFB74D",
          fontSize: "20px",
          cursor: "pointer",
          padding: "0",
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: 0.7,
          transition: "opacity 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = "0.7";
        }}
      >
        ×
      </button>
      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
        <div
          style={{
            fontSize: "20px",
            lineHeight: "1",
            flexShrink: 0,
          }}
        >
          ⚠️
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#FFB74D",
              marginBottom: "8px",
            }}
          >
            隐私安全提示
          </div>
          <div
            style={{
              fontSize: "13px",
              color: "#E0E0E0",
              lineHeight: "1.6",
            }}
          >
            本服务采用明文存储，存在隐私泄漏风险。请<strong style={{ color: "#FFB74D" }}>不要</strong>存储以下敏感信息：
            密码、银行卡号、身份证号、手机号、邮箱密码、API密钥、私钥、个人隐私信息等。
            <strong style={{ color: "#FFB74D" }}>特别注意：</strong>请勿泄漏您的登录用户名和密码，否则可能导致账户被盗用。
            建议仅用于临时文本存储，重要数据请使用专业的加密存储服务。
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;
